import React from "react";

export default function ChinaNewYearFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-1cn1{fill:#d34d29}.cls-1cn3{fill:#af0000}.cls-1cn4{fill:#eddd48}"
            }
          </style>
        </defs>
        <rect
          width={1488.61}
          height={1605.31}
          x={299.31}
          y={219.17}
          rx={178.61}
          ry={178.61}
          style={{
            fill: "none",
            stroke: "#962f1b",
            strokeMiterlimit: 10,
            strokeWidth: "34.88px",
          }}
        />
        <path
          d="m1786.27 1361.87-29.4-155.07c-.05-.27-.02-.55.08-.8 5.32-12.63 17.82-20.79 31.4-20.5 13.07.29 24.84 8.35 29.95 20.5.11.25.13.53.08.8l-29.4 155.07c-.28 1.5-2.43 1.5-2.71 0Z"
          className="cls-1cn3"
        />
        <path
          d="m1786.28 1361.24 41.14-152.38c.07-.26.22-.5.42-.69 10.29-9.05 25.1-10.94 37.2-4.76 11.64 5.95 18.72 18.34 18.02 31.5-.01.27-.11.54-.27.76-31.35 42.25-62.71 84.5-94.06 126.75-.91 1.22-2.84.29-2.44-1.18Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.24 1360.7 102.17-120.31c.18-.21.41-.36.68-.44 13.17-3.8 27.37.8 35.68 11.55 7.99 10.35 9.11 24.57 2.87 36.18-.13.24-.33.44-.57.57-46.37 24.85-92.74 49.71-139.11 74.56-1.34.72-2.69-.95-1.71-2.11Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.73 1360.32 144.4-63.74c.25-.11.53-.15.8-.1 13.51 2.32 24.29 12.65 27.07 25.95 2.68 12.8-2.51 26.09-13.19 33.81-.22.16-.49.25-.76.26-52.57 2.15-105.14 4.31-157.7 6.46-1.52.06-2.01-2.03-.61-2.64Z"
          className="cls-1cn3"
        />
        <path
          d="m1786.74 1359.76 157.82 2.58c.27 0 .54.09.77.24 11.29 7.76 16.76 21.66 13.72 34.9-2.92 12.74-13.2 22.64-26.13 25.18-.27.05-.55.02-.8-.08-48.64-20.06-97.28-40.11-145.92-60.17-1.41-.58-.98-2.68.55-2.66Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.35 1359.9 140.91 71.12c.24.12.45.32.59.55 6.78 11.91 5.64 26.8-2.87 37.39-8.19 10.19-21.75 14.62-34.49 11.27-.26-.07-.5-.22-.68-.42l-105.1-117.76c-1.02-1.14.29-2.84 1.65-2.15Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.69 1360.94 97.15 124.39c.17.22.27.48.29.75 1.06 13.66-6.32 26.64-18.53 32.6-11.75 5.73-25.91 3.95-36.01-4.51-.21-.18-.36-.41-.44-.67l-44.88-151.32c-.43-1.46 1.47-2.44 2.41-1.24Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.97 1361.5 33.21 154.3c.06.27.04.55-.06.8-5.01 12.76-17.3 21.22-30.89 21.26-13.07.04-25.04-7.74-30.44-19.75-.11-.25-.15-.53-.1-.8 8.53-51.92 17.05-103.83 25.58-155.75.25-1.5 2.39-1.56 2.71-.07Z"
          className="cls-1cn3"
        />
        <path
          d="m1788.77 1360.89-41.39 152.31c-.07.26-.22.5-.42.68-10.31 9.03-25.12 10.9-37.2 4.69-11.63-5.97-18.69-18.37-17.96-31.53.01-.27.11-.54.28-.76 31.42-42.2 62.85-84.39 94.27-126.59.91-1.22 2.84-.28 2.44 1.19Z"
          className="cls-1cn3"
        />
        <path
          d="m1788.49 1361.45-103.65 119.03c-.18.21-.42.36-.68.43-13.21 3.64-27.36-1.14-35.53-11.99-7.86-10.45-8.81-24.68-2.42-36.21.13-.24.34-.43.58-.56 46.68-24.28 93.35-48.56 140.03-72.83 1.35-.7 2.68.98 1.68 2.13Z"
          className="cls-1cn3"
        />
        <path
          d="m1789.61 1361.53-143.97 64.69c-.25.11-.53.15-.8.11-13.52-2.23-24.37-12.49-27.24-25.77-2.77-12.78 2.34-26.1 12.96-33.9.22-.16.49-.25.76-.27 52.55-2.5 105.11-5.01 157.66-7.51 1.52-.07 2.02 2.01.63 2.64Z"
          className="cls-1cn3"
        />
        <path
          d="m1789.01 1361.67-157.77-4.54c-.27 0-.54-.09-.77-.25-11.2-7.9-16.49-21.86-13.29-35.07 3.08-12.71 13.48-22.47 26.44-24.86.27-.05.55-.02.8.09 48.39 20.66 96.78 41.31 145.16 61.97 1.4.6.94 2.69-.58 2.65Z"
          className="cls-1cn3"
        />
        <path
          d="m1788.26 1360.86-140.79-71.35c-.24-.12-.45-.32-.58-.55-6.76-11.92-5.6-26.81 2.93-37.38 8.2-10.18 21.77-14.58 34.51-11.21.26.07.5.22.68.42 34.97 39.31 69.93 78.62 104.9 117.93 1.01 1.14-.3 2.84-1.66 2.15Z"
          className="cls-1cn3"
        />
        <path
          d="m1787.77 1360.47-95.6-125.59c-.17-.22-.27-.48-.28-.75-.89-13.68 6.65-26.56 18.93-32.37 11.82-5.59 25.95-3.63 35.95 4.95.21.18.36.42.43.68 14.33 50.62 28.67 101.24 43 151.87.42 1.47-1.5 2.43-2.43 1.21Z"
          className="cls-1cn3"
        />
        <circle cx={1791.74} cy={1360.37} r={25.75} className="cls-1cn1" />
        <path
          d="M320.08 689.79 280.06 478.7c-.07-.37-.03-.75.11-1.09 7.24-17.19 24.26-28.3 42.75-27.9 17.79.39 33.81 11.37 40.76 27.9.14.34.18.72.11 1.09l-40.02 211.09c-.39 2.04-3.31 2.04-3.69 0Z"
          className="cls-1cn3"
        />
        <path
          d="m320.09 688.94 56-207.43c.1-.36.3-.69.58-.93 14.01-12.32 34.17-14.9 50.63-6.47 15.84 8.11 25.48 24.97 24.52 42.88-.02.37-.15.73-.37 1.03L323.41 690.55c-1.24 1.67-3.87.39-3.32-1.61Z"
          className="cls-1cn3"
        />
        <path
          d="m321.39 688.21 139.08-163.77c.24-.28.56-.49.92-.6 17.93-5.17 37.26 1.09 48.56 15.73 10.88 14.09 12.4 33.45 3.91 49.24-.18.33-.45.6-.78.77-63.12 33.83-126.25 67.67-189.37 101.5-1.83.98-3.66-1.29-2.32-2.87Z"
          className="cls-1cn3"
        />
        <path
          d="m322.06 687.68 196.56-86.76c.34-.15.72-.2 1.09-.14 18.39 3.16 33.06 17.22 36.85 35.32 3.65 17.42-3.42 35.51-17.95 46.02-.3.22-.66.34-1.04.36-71.56 2.93-143.12 5.86-214.67 8.8-2.07.09-2.74-2.76-.84-3.6Z"
          className="cls-1cn3"
        />
        <path
          d="m320.72 686.93 214.82 3.51c.37 0 .74.12 1.05.33 15.37 10.57 22.81 29.48 18.67 47.51-3.98 17.35-17.97 30.81-35.57 34.28-.37.07-.75.03-1.09-.11l-198.63-81.9c-1.92-.79-1.33-3.65.75-3.62Z"
          className="cls-1cn3"
        />
        <path
          d="m321.55 687.11 191.81 96.81c.33.17.61.43.8.75 9.23 16.21 7.68 36.48-3.9 50.9-11.14 13.88-29.61 19.9-46.96 15.34-.36-.09-.68-.3-.93-.57-47.69-53.43-95.38-106.87-143.06-160.3-1.38-1.55.4-3.87 2.25-2.93Z"
          className="cls-1cn3"
        />
        <path
          d="m322 688.53 132.25 169.33c.23.29.37.65.4 1.02 1.44 18.6-8.6 36.27-25.22 44.38-15.99 7.8-35.26 5.38-49.02-6.14a1.9 1.9 0 0 1-.6-.92c-20.36-68.66-40.73-137.32-61.09-205.99-.59-1.99 2.01-3.33 3.28-1.69Z"
          className="cls-1cn3"
        />
        <path
          d="m322.38 689.29 45.2 210.04c.08.36.05.75-.09 1.09-6.81 17.37-23.55 28.89-42.05 28.94-17.8.05-34.08-10.53-41.44-26.89-.15-.34-.2-.72-.14-1.09 11.61-70.67 23.21-141.34 34.82-212.01.34-2.05 3.26-2.12 3.69-.09Z"
          className="cls-1cn3"
        />
        <path
          d="m323.47 688.46-56.35 207.33c-.1.36-.3.69-.58.93-14.03 12.3-34.19 14.84-50.64 6.39-15.83-8.13-25.44-25.01-24.45-42.92.02-.37.15-.73.38-1.03 42.78-57.44 85.55-114.88 128.33-172.32 1.24-1.67 3.87-.39 3.32 1.62Z"
          className="cls-1cn3"
        />
        <path
          d="M323.09 689.22 182 851.25c-.24.28-.57.49-.93.59-17.99 4.95-37.24-1.55-48.36-16.33-10.7-14.22-11.99-33.6-3.3-49.29.18-.33.46-.59.79-.76 63.54-33.05 127.07-66.1 190.61-99.15 1.84-.96 3.65 1.34 2.29 2.9Z"
          className="cls-1cn3"
        />
        <path
          d="m324.63 689.33-195.98 88.06c-.34.15-.72.21-1.09.14-18.41-3.04-33.17-17-37.08-35.08-3.76-17.39 3.18-35.53 17.64-46.14.3-.22.66-.34 1.03-.36 71.54-3.41 143.07-6.82 214.61-10.22 2.07-.1 2.75 2.74.86 3.59Z"
          className="cls-1cn3"
        />
        <path
          d="m323.8 689.52-214.76-6.17c-.37-.01-.74-.13-1.04-.34-15.24-10.76-22.44-29.76-18.08-47.73 4.19-17.29 18.35-30.59 35.99-33.83.37-.07.75-.02 1.09.12 65.87 28.12 131.73 56.24 197.6 84.35 1.91.82 1.28 3.67-.79 3.61Z"
          className="cls-1cn3"
        />
        <path
          d="m322.78 688.42-191.65-97.13c-.33-.17-.61-.43-.8-.75-9.2-16.23-7.62-36.49 3.99-50.89 11.17-13.86 29.64-19.85 46.98-15.26.36.1.68.3.93.58l142.8 160.53c1.38 1.55-.4 3.86-2.25 2.93Z"
          className="cls-1cn3"
        />
        <path
          d="M322.12 687.89 191.98 516.93c-.23-.3-.36-.65-.39-1.03-1.21-18.62 9.05-36.16 25.77-44.06 16.09-7.6 35.33-4.94 48.94 6.74.28.24.49.57.59.92l58.53 206.73c.57 2-2.05 3.3-3.3 1.65Z"
          className="cls-1cn3"
        />
        <circle cx={327.52} cy={687.75} r={35.05} className="cls-1cn1" />
        <path
          d="m1760.74 1756.95-71.16-176.9a1.7 1.7 0 0 1-.09-.97c3.34-16.22 16.25-28.81 32.42-31.64 15.56-2.72 31.39 4.08 40.29 17.28.18.27.28.6.28.93l1.47 190.67c.01 1.84-2.53 2.34-3.22.64Z"
          className="cls-1cn1"
        />
        <path
          d="m1760.61 1756.21 13.07-190.23c.02-.33.14-.65.34-.91 10.08-13.14 27.18-18.85 42.97-14.35 15.19 4.33 26.48 17.36 28.73 33.11.05.33 0 .66-.15.96-27.26 57.41-54.53 114.83-81.79 172.24-.79 1.66-3.3 1.01-3.17-.83Z"
          className="cls-1cn1"
        />
        <path
          d="m1761.61 1755.35 92.91-166.51c.16-.29.4-.53.7-.68 14.72-7.59 32.63-5.46 44.99 5.34 11.89 10.39 16.55 26.99 11.87 42.2-.1.32-.29.6-.54.81l-147.41 120.95c-1.42 1.17-3.41-.49-2.52-2.1Z"
          className="cls-1cn1"
        />
        <path
          d="m1762.1 1754.77 156.2-109.35c.27-.19.59-.3.92-.31 16.55-.41 31.74 9.31 38.16 24.41 6.17 14.54 3.13 31.5-7.71 43.16-.22.24-.52.41-.84.49-61.8 14.86-123.59 29.73-185.39 44.59-1.79.43-2.86-1.93-1.35-2.99Z"
          className="cls-1cn1"
        />
        <path
          d="m1760.81 1754.35 187.64-33.9c.33-.06.66-.02.97.11 15.2 6.56 24.93 21.74 24.43 38.15-.48 15.79-10.35 29.92-25.07 35.96-.31.13-.64.16-.97.09-62.34-12.38-124.68-24.76-187.03-37.13-1.81-.36-1.78-2.95.03-3.28Z"
          className="cls-1cn1"
        />
        <path
          d="m1761.56 1754.37 183.65 51.29c.32.09.61.27.82.52 10.83 12.53 12.96 30.44 5.36 44.98-7.31 14-22.35 22.42-38.24 21.44-.33-.02-.65-.14-.91-.34-50.71-38.32-101.42-76.63-152.13-114.95-1.47-1.11-.32-3.43 1.45-2.94Z"
          className="cls-1cn1"
        />
        <path
          d="m1762.2 1755.53 144.27 124.68c.25.22.43.5.52.82 4.45 15.95-1.25 33.06-14.33 42.98-12.58 9.54-29.78 10.75-43.73 3.09a1.7 1.7 0 0 1-.68-.7c-29.54-56.28-59.08-112.55-88.62-168.83-.86-1.63 1.17-3.24 2.57-2.04Z"
          className="cls-1cn1"
        />
        <path
          d="m1762.66 1756.12 75.49 175.1c.13.3.17.64.11.97-2.94 16.29-15.53 29.21-31.63 32.43-15.49 3.1-31.49-3.3-40.7-16.28-.19-.27-.3-.59-.31-.92-2.05-63.53-4.11-127.05-6.16-190.58-.06-1.84 2.47-2.41 3.2-.71Z"
          className="cls-1cn1"
        />
        <path
          d="m1763.47 1755.21-13.39 190.21c-.02.33-.14.65-.34.91-10.1 13.12-27.22 18.8-42.99 14.28-15.18-4.36-26.45-17.4-28.67-33.16-.05-.33 0-.66.15-.96l82.08-172.11c.79-1.66 3.3-1 3.17.84Z"
          className="cls-1cn1"
        />
        <path
          d="m1763.27 1755.93-94.97 165.34c-.16.29-.41.52-.71.67-14.81 7.4-32.69 5.06-44.92-5.89-11.76-10.54-16.22-27.19-11.35-42.34.1-.31.3-.59.55-.8 49.63-39.7 99.26-79.41 148.9-119.11 1.44-1.15 3.41.54 2.49 2.13Z"
          className="cls-1cn1"
        />
        <path
          d="m1764.62 1755.77-155.47 110.39c-.27.19-.59.3-.92.31-16.55.52-31.81-9.09-38.32-24.16-6.27-14.5-3.34-31.48 7.42-43.21.22-.24.52-.41.84-.49 61.7-15.27 123.39-30.55 185.09-45.82 1.79-.44 2.87 1.91 1.37 2.98Z"
          className="cls-1cn1"
        />
        <path
          d="m1763.94 1756.07-188.04 31.57c-.33.05-.66.01-.97-.12-15.12-6.74-24.66-22.05-23.96-38.45.68-15.78 10.72-29.79 25.52-35.65.31-.12.65-.15.97-.08l186.55 39.45c1.8.38 1.75 2.97-.07 3.28Z"
          className="cls-1cn1"
        />
        <path
          d="m1762.86 1755.29-183.56-51.59c-.32-.09-.61-.27-.82-.52-10.8-12.55-12.91-30.46-5.28-44.99 7.34-13.99 22.39-22.38 38.28-21.37.33.02.65.14.91.34 50.65 38.4 101.29 76.8 151.94 115.2 1.47 1.11.31 3.43-1.46 2.94Z"
          className="cls-1cn1"
        />
        <path
          d="m1762.19 1754.95-142.71-126.45c-.25-.22-.43-.51-.51-.83-4.25-16 1.66-33.04 14.86-42.8 12.7-9.39 29.91-10.38 43.77-2.55.29.16.52.41.67.7 28.84 56.64 57.68 113.28 86.53 169.91.84 1.64-1.21 3.23-2.59 2.01Z"
          className="cls-1cn1"
        />
        <circle cx={1763.31} cy={1756.21} r={31.11} className="cls-1cn4" />
        <path
          d="m726.91 215.96-42.27-168.4c-.07-.29-.06-.6.04-.89 5.03-14.21 18.23-23.98 33.17-24.53 14.37-.53 27.82 7.57 34.21 20.58.13.27.18.57.14.87-7.43 57.4-14.87 114.79-22.3 172.19-.22 1.66-2.57 1.8-2.98.17Z"
          className="cls-1cn1"
        />
        <path
          d="m726.88 215.27 35.37-169.98c.06-.29.21-.57.42-.78 10.72-10.6 26.86-13.64 40.54-7.62 13.16 5.79 21.73 18.94 21.81 33.43 0 .3-.09.6-.25.85-31.71 48.41-63.42 96.83-95.13 145.24-.92 1.4-3.1.5-2.76-1.14Z"
          className="cls-1cn1"
        />
        <path
          d="M727.9 214.62 832.35 75.93c.18-.24.43-.43.71-.53 14.22-5.02 30.11-.89 39.92 10.39 9.44 10.85 11.59 26.4 5.48 39.54-.13.27-.33.5-.59.66-49.32 30.28-98.64 60.56-147.97 90.84-1.43.88-3.02-.87-2.01-2.21Z"
          className="cls-1cn1"
        />
        <path
          d="m728.41 214.16 154.46-79.29c.27-.14.57-.2.87-.16 14.98 1.68 27.48 12.33 31.4 26.75 3.77 13.88-1.08 28.81-12.3 37.98-.23.19-.52.31-.82.34l-172.77 17.25c-1.67.17-2.34-2.1-.84-2.86Z"
          className="cls-1cn1"
        />
        <path
          d="m727.29 213.62 173.47-7.33c.3-.01.6.06.86.22 12.9 7.8 19.8 22.7 17.31 37.44-2.39 14.18-13.04 25.71-27.07 29.33-.29.08-.6.06-.88-.04-54.71-18.89-109.41-37.78-164.12-56.68-1.59-.55-1.24-2.88.43-2.95Z"
          className="cls-1cn1"
        />
        <path
          d="m727.97 213.73 159.31 69.03c.28.12.51.32.68.57 8.21 12.64 7.92 29.06-.74 41.24-8.33 11.72-22.94 17.45-37.15 14.6a1.57 1.57 0 0 1-.78-.42c-41-40.85-82-81.7-122.99-122.55-1.19-1.18.14-3.14 1.68-2.47Z"
          className="cls-1cn1"
        />
        <path
          d="M728.4 214.85 843.09 345.2c.2.23.33.51.37.81 2.04 14.94-5.22 29.67-18.25 36.99-12.53 7.05-28.19 6.01-39.83-2.63-.24-.18-.42-.43-.53-.71-19.68-54.43-39.35-108.86-59.03-163.28-.57-1.58 1.46-2.78 2.57-1.52Z"
          className="cls-1cn1"
        />
        <path
          d="m728.75 215.45 46.4 167.31c.08.29.08.6-.02.89-4.68 14.33-17.63 24.42-32.55 25.34-14.35.88-27.99-6.88-34.7-19.73-.14-.27-.19-.57-.16-.87l18.06-172.68c.17-1.67 2.53-1.86 2.97-.25Z"
          className="cls-1cn1"
        />
        <path
          d="m729.59 214.72-35.65 169.93c-.06.29-.21.57-.42.78-10.74 10.58-26.88 13.59-40.55 7.55-13.15-5.81-21.7-18.97-21.76-33.47 0-.3.09-.6.25-.85 31.79-48.36 63.58-96.72 95.37-145.09.92-1.4 3.1-.5 2.76 1.15Z"
          className="cls-1cn1"
        />
        <path
          d="M729.32 215.35 623.16 352.74c-.18.24-.43.42-.72.52-14.28 4.84-30.12.51-39.79-10.88-9.31-10.96-11.26-26.54-4.99-39.61.13-.27.34-.5.6-.65 49.69-29.67 99.39-59.33 149.08-89 1.44-.86 3.01.91 1.98 2.23Z"
          className="cls-1cn1"
        />
        <path
          d="m730.56 215.37-153.93 80.31c-.27.14-.57.2-.87.17-14.99-1.58-27.57-12.15-31.58-26.54-3.86-13.85.89-28.81 12.05-38.06.23-.19.52-.31.82-.34 57.55-6.13 115.1-12.27 172.65-18.4 1.67-.18 2.35 2.08.86 2.86Z"
          className="cls-1cn1"
        />
        <path
          d="m729.9 215.56-173.55 5.18c-.3 0-.6-.07-.86-.23-12.81-7.96-19.51-22.95-16.85-37.65 2.57-14.15 13.36-25.55 27.44-29 .29-.07.6-.05.88.05 54.47 19.57 108.93 39.14 163.4 58.7 1.58.57 1.21 2.9-.47 2.95Z"
          className="cls-1cn1"
        />
        <path
          d="m729.03 214.73-159.2-69.29c-.28-.12-.51-.32-.68-.57-8.19-12.66-7.87-29.08.81-41.24 8.35-11.71 22.97-17.41 37.18-14.54.29.06.57.21.78.42 40.93 40.92 81.86 81.84 122.79 122.75 1.19 1.19-.14 3.14-1.68 2.47Z"
          className="cls-1cn1"
        />
        <path
          d="M728.47 214.33 615.4 82.57c-.2-.23-.32-.51-.36-.81-1.86-14.96 5.59-29.6 18.71-36.76 12.62-6.9 28.27-5.66 39.8 3.12.24.18.42.43.52.72 19 54.67 38 109.34 57 164 .55 1.58-1.5 2.76-2.59 1.49Z"
          className="cls-1cn1"
        />
        <circle cx={729.32} cy={215.61} r={28.32} className="cls-1cn4" />
        <path
          d="m1404.31 1825.95-25.6-135.02c-.04-.23-.02-.48.07-.7 4.63-11 15.51-18.1 27.34-17.84 11.38.25 21.63 7.27 26.07 17.85.09.22.12.46.07.7-8.53 45.01-17.07 90.01-25.6 135.02-.25 1.3-2.12 1.3-2.36 0Z"
          className="cls-1cn4"
        />
        <path
          d="m1404.32 1825.41 35.82-132.67c.06-.23.19-.44.37-.6 8.96-7.88 21.85-9.53 32.39-4.14 10.13 5.18 16.29 15.97 15.69 27.43-.01.24-.1.47-.24.66-27.3 36.78-54.6 73.57-81.9 110.35-.79 1.07-2.47.25-2.13-1.03Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.15 1824.94 88.95-104.75c.15-.18.36-.32.59-.38 11.47-3.31 23.83.69 31.06 10.06 6.96 9.01 7.93 21.39 2.5 31.5-.11.21-.29.38-.5.49-40.37 21.64-80.75 43.28-121.12 64.92-1.17.63-2.34-.83-1.48-1.84Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.58 1824.61 125.72-55.49c.22-.1.46-.13.7-.09 11.76 2.02 21.14 11.01 23.57 22.59 2.33 11.14-2.19 22.71-11.48 29.44-.19.14-.42.22-.66.23-45.77 1.88-91.54 3.75-137.31 5.63-1.33.05-1.75-1.77-.53-2.3Z"
          className="cls-1cn4"
        />
        <path
          d="m1404.72 1824.12 137.4 2.25c.24 0 .47.08.67.21 9.83 6.76 14.59 18.86 11.94 30.39-2.55 11.09-11.49 19.71-22.75 21.92-.23.05-.48.02-.7-.07l-127.05-52.38c-1.23-.51-.85-2.34.48-2.31Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.25 1824.24 122.68 61.92c.21.11.39.27.51.48 5.9 10.37 4.91 23.33-2.5 32.55-7.13 8.88-18.94 12.73-30.03 9.81-.23-.06-.44-.19-.6-.37-30.5-34.18-61-68.35-91.5-102.53-.88-.99.25-2.47 1.44-1.87Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.54 1825.15 84.58 108.31c.15.19.24.42.26.65.92 11.9-5.5 23.2-16.13 28.38-10.23 4.99-22.56 3.44-31.35-3.92-.18-.15-.31-.36-.38-.59-13.02-43.92-26.05-87.83-39.07-131.75-.38-1.27 1.28-2.13 2.1-1.08Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.79 1825.64 28.91 134.35c.05.23.03.48-.05.7-4.36 11.11-15.06 18.48-26.89 18.51-11.38.03-21.8-6.74-26.5-17.2-.1-.22-.13-.46-.09-.69 7.42-45.2 14.85-90.4 22.27-135.61.22-1.31 2.08-1.36 2.36-.06Z"
          className="cls-1cn4"
        />
        <path
          d="m1406.48 1825.1-36.04 132.61c-.06.23-.19.44-.37.6-8.97 7.86-21.87 9.49-32.39 4.09-10.12-5.2-16.27-16-15.64-27.45.01-.24.1-.47.24-.66l82.08-110.22c.79-1.07 2.47-.25 2.12 1.03Z"
          className="cls-1cn4"
        />
        <path
          d="M1406.24 1825.59 1316 1929.23c-.16.18-.36.31-.59.38-11.51 3.17-23.82-.99-30.93-10.44-6.84-9.09-7.67-21.49-2.11-31.53.12-.21.29-.38.5-.49 40.64-21.14 81.28-42.28 121.92-63.41 1.18-.61 2.33.86 1.46 1.86Z"
          className="cls-1cn4"
        />
        <path
          d="m1407.22 1825.66-125.35 56.33c-.22.1-.46.13-.7.09-11.77-1.94-21.22-10.87-23.72-22.44-2.41-11.12 2.03-22.73 11.29-29.51.19-.14.42-.22.66-.23l137.27-6.54c1.33-.06 1.76 1.75.55 2.3Z"
          className="cls-1cn4"
        />
        <path
          d="m1406.69 1825.78-137.36-3.95c-.24 0-.47-.08-.67-.22-9.75-6.88-14.36-19.03-11.57-30.53 2.68-11.06 11.74-19.57 23.02-21.64.23-.04.48-.01.7.08 42.13 17.98 84.26 35.97 126.39 53.95 1.22.52.82 2.35-.51 2.31Z"
          className="cls-1cn4"
        />
        <path
          d="m1406.04 1825.08-122.58-62.12c-.21-.11-.39-.28-.51-.48-5.89-10.38-4.87-23.34 2.55-32.55 7.14-8.86 18.96-12.7 30.05-9.76.23.06.44.19.6.37 30.44 34.23 60.89 68.45 91.33 102.68.88.99-.26 2.47-1.44 1.87Z"
          className="cls-1cn4"
        />
        <path
          d="m1405.62 1824.74-83.24-109.35c-.14-.19-.23-.42-.25-.66-.77-11.91 5.79-23.13 16.48-28.18 10.29-4.86 22.6-3.16 31.3 4.31.18.16.31.36.38.59l37.44 132.22c.36 1.28-1.31 2.11-2.11 1.06Z"
          className="cls-1cn4"
        />
        <circle cx={1406.23} cy={1825.79} r={22.42} className="cls-1cn1" />
        <path
          d="m360.88 276.6-28.91-152.51c-.05-.26-.02-.54.08-.79 5.23-12.42 17.52-20.45 30.88-20.16 12.85.28 24.43 8.21 29.45 20.16.1.25.13.52.08.79-9.64 50.84-19.28 101.67-28.91 152.51-.28 1.47-2.39 1.47-2.67 0Z"
          className="cls-1cn4"
        />
        <path
          d="m360.89 275.99 40.46-149.86c.07-.26.21-.5.42-.67 10.12-8.9 24.69-10.76 36.58-4.68 11.45 5.86 18.41 18.04 17.72 30.98-.01.27-.11.53-.27.74-30.84 41.55-61.67 83.1-92.51 124.65-.89 1.2-2.79.28-2.4-1.16Z"
          className="cls-1cn4"
        />
        <path
          d="m361.83 275.46 100.48-118.32c.17-.21.41-.36.66-.43 12.95-3.74 26.92.78 35.09 11.36 7.86 10.18 8.96 24.16 2.82 35.58-.13.24-.32.43-.56.56-45.6 24.44-91.21 48.89-136.81 73.33-1.32.71-2.65-.93-1.68-2.08Z"
          className="cls-1cn4"
        />
        <path
          d="m362.31 275.08 142.01-62.68c.25-.11.52-.14.79-.1 13.28 2.28 23.88 12.44 26.62 25.52 2.64 12.58-2.47 25.65-12.97 33.25-.22.16-.48.25-.75.26l-155.1 6.36c-1.5.06-1.98-1.99-.6-2.6Z"
          className="cls-1cn4"
        />
        <path
          d="m361.34 274.53 155.2 2.54c.27 0 .53.09.76.24 11.11 7.64 16.48 21.3 13.49 34.32-2.88 12.53-12.98 22.26-25.7 24.76-.26.05-.54.02-.79-.08-47.84-19.72-95.67-39.45-143.51-59.17-1.39-.57-.96-2.64.54-2.61Z"
          className="cls-1cn4"
        />
        <path
          d="m361.94 274.66 138.57 69.94c.24.12.44.31.58.54 6.67 11.71 5.55 26.35-2.82 36.77-8.05 10.02-21.39 14.38-33.92 11.08-.26-.07-.49-.21-.67-.41L360.32 276.77c-1-1.12.29-2.79 1.63-2.12Z"
          className="cls-1cn4"
        />
        <path
          d="m362.27 275.69 95.54 122.34c.17.21.27.47.29.74 1.04 13.44-6.21 26.2-18.22 32.06-11.56 5.64-25.48 3.89-35.41-4.43-.21-.17-.36-.4-.43-.66-14.71-49.61-29.42-99.21-44.14-148.82-.43-1.44 1.45-2.4 2.37-1.22Z"
          className="cls-1cn4"
        />
        <path
          d="m362.54 276.24 32.66 151.75c.06.26.04.54-.06.79-4.92 12.55-17.02 20.87-30.38 20.91-12.86.04-24.62-7.61-29.94-19.43-.11-.25-.14-.52-.1-.78 8.38-51.06 16.77-102.12 25.15-153.17.24-1.48 2.35-1.53 2.67-.07Z"
          className="cls-1cn4"
        />
        <path
          d="m363.33 275.64-40.71 149.79c-.07.26-.22.5-.42.67-10.14 8.88-24.7 10.72-36.59 4.62-11.44-5.87-18.38-18.07-17.67-31.01.01-.27.11-.53.27-.74 30.9-41.5 61.81-83 92.71-124.5.9-1.2 2.79-.28 2.4 1.17Z"
          className="cls-1cn4"
        />
        <path
          d="M363.06 276.19 261.12 393.25c-.18.2-.41.35-.67.42-13 3.58-26.91-1.12-34.94-11.79-7.73-10.27-8.66-24.27-2.38-35.61.13-.24.33-.43.57-.55 45.9-23.88 91.81-47.75 137.71-71.63 1.33-.69 2.64.97 1.65 2.1Z"
          className="cls-1cn4"
        />
        <path
          d="m364.16 276.27-141.59 63.62c-.25.11-.52.15-.79.1-13.3-2.19-23.97-12.28-26.79-25.34-2.72-12.57 2.3-25.67 12.75-33.33.22-.16.48-.25.75-.26 51.68-2.46 103.37-4.92 155.05-7.39 1.5-.07 1.99 1.98.62 2.6Z"
          className="cls-1cn4"
        />
        <path
          d="m363.57 276.4-155.16-4.46c-.27 0-.53-.09-.75-.25-11.01-7.77-16.21-21.5-13.07-34.49 3.03-12.5 13.26-22.1 26-24.44.26-.05.54-.02.79.09 47.59 20.31 95.17 40.63 142.76 60.94 1.38.59.93 2.65-.57 2.61Z"
          className="cls-1cn4"
        />
        <path
          d="m362.83 275.61-138.46-70.17c-.24-.12-.44-.31-.57-.55-6.65-11.72-5.5-26.36 2.88-36.77 8.07-10.01 21.41-14.34 33.94-11.03.26.07.49.22.67.42l103.17 115.98c1 1.12-.29 2.79-1.63 2.11Z"
          className="cls-1cn4"
        />
        <path
          d="m362.35 275.23-94.02-123.51a1.4 1.4 0 0 1-.28-.74c-.87-13.45 6.54-26.12 18.62-31.83 11.62-5.49 25.52-3.57 35.35 4.87.2.18.35.41.42.67 14.1 49.78 28.19 99.57 42.29 149.35.41 1.44-1.48 2.39-2.39 1.19Z"
          className="cls-1cn4"
        />
        <circle cx={363.04} cy={276.42} r={25.32} className="cls-1cn1" />
        {children}
      </g>
    </svg>
  );
}
